import { CorePaymentMethod } from "@oysterhr/schema"
import { Text, Alert, Toast, useToast } from "@oysterhr/ui"

import { isUnverifiable } from "../utils"

import { useDeletePaymentMethod } from "../actions"

interface ErrorVerificationCountAlertProps {
  paymentMethod: CorePaymentMethod
  refetch: () => void
}

export const ErrorVerificationCountAlert = ({
  paymentMethod,
  refetch,
}: ErrorVerificationCountAlertProps) => {
  const toast = useToast()

  const { deletePaymentMethod, loading } = useDeletePaymentMethod({
    successCallback: () => {
      toast({
        render: (
          <Toast>
            <Toast.Content>Payment method has been deleted.</Toast.Content>
          </Toast>
        ),
      })
      refetch()
    },
    failureCallback: errors => {
      toast({
        render: (
          <Toast variation="error">
            <Toast.Content>{errors.join(", ")}</Toast.Content>
          </Toast>
        ),
      })
    },
  })

  return paymentMethod && isUnverifiable(paymentMethod) ? (
    <Alert variation="error">
      <Alert.Icon />
      <Alert.Content>
        <div className="flex">
          <Text>
            {"We couldn't verify this account. Please try removing it and adding it again."}
          </Text>
          &nbsp;
          {/* FIXME: Shouldn't we use design system component Button here?! */}
          <button
            type="button"
            className="font-normal underline"
            disabled={loading}
            onClick={() => {
              deletePaymentMethod(paymentMethod)
            }}
          >
            Remove payment method
          </button>
        </div>
      </Alert.Content>
    </Alert>
  ) : null
}
